import { JustpayUserEndpoint } from "@/views/loyalty/shared/endpoint_services/justpay-user-endpoint-service"

export class JustpayUser {
    constructor () {
        this.justpayUserEndpoint = new JustpayUserEndpoint()
    }

    async getForFiltering () {
        const users = await this.justpayUserEndpoint.getForFiltering()
        // console.log('users->', users)
        return users || []
    }

    async getUsers () {
        const users = await this.justpayUserEndpoint.getUsers()
        // console.log('users->', users)
        return users || []
    }

    async getUsersByCustomerId (customerId) {
        const users = await this.justpayUserEndpoint.getUsers()
        // console.log('users->', users)
        return users ? users.data.filter(user => {
            // console.log('user->', user)
            // return user.children_clients ? user.children_clients.includes(customerId) : false
            return user.organizations.some(s => s.client === customerId && (s.role === 3 || s.custom_role))
}) : []
    }

    async getAllUsersByCustomerId (customerId) {
        const users = await this.justpayUserEndpoint.getForFiltering()
        // console.log('users->', users)
        if (customerId === '0') return users.data
        else {
 return users ? users.data.filter(user => {
            return user.organizations.some(s => s.client === customerId)
        }) : []
}
    }
}
